<template>
	<div class="row no-gutters">
		<div class="col-12 col-sm-4">
			<date-picker
				v-model="selectedDate"
				:initial-date="initialDate"
				v-on:change="update">
			</date-picker>
		</div>
		<div class="col-12 col-sm-8">
			<div class="row no-gutters">
				<div class="col-4">
					<select class="form-control" v-model="selectedHr" v-on:change="update">
						<option v-for="hr in hrs">{{ hr }}</option>
					</select>
				</div>
				<div class="col-4">
					<select class="form-control" v-model="selectedMin" v-on:change="update">
						<option v-for="min in mins">{{ min }}</option>
					</select>
				</div>
				<div class="col-4">
					<button-group v-model="selectedAmPm" v-on:change="update" :buttons="[{text: 'AM',value:'AM'},{text: 'PM',value:'PM'}]"></button-group>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
import DatePicker from "./DatePicker"
import ButtonGroup from "./ButtonGroup"

export default {
	name: "DateTimePicker",
	components: {
		DatePicker,
		ButtonGroup
	},
	props: ["value","minuteStep","initialDate","inputInUtc"],
	data() {
		return {
			selectedDate: null,
			selectedHr: 0,
			selectedMin: 0,
			selectedAmPm: "AM"
		}
	},
	watch: {
		value() {
			if (new Date(this.value) != new Date("null 00")) {
				let value = this.value

				let datetime = new Date(value)

				if (this.inputInUtc) 
					value = this.moment.utc(datetime).local().format("YYYY-MM-DD HH:mm")

				//split value into components
				let split = value.split(" ")
				this.selectedDate = split[0]

				let hr24 = split[1].split(":")[0]
				let min = split[1].split(":")[1]

				if (parseInt(hr24) > 12) {
					this.selectedHr = parseInt(hr24) - 12
					this.selectedAmPm = "PM"

					if (this.selectedHr < 10)
						this.selectedHr = "0"+this.selectedHr
				}
				else {
					this.selectedHr = hr24
					this.selectedAmPm = "AM"
				}

				this.selectedMin = ":"+parseInt(min)
			}
			else {
				this.selectedHr = "00"
				this.selectedMin = ":00"
				this.selectedDate = "today"
				this.selectedAmPm = "AM"
			}
		}
	},
	methods: {
		update() {
			let hr24 = this.selectedHr
			if (this.selectedAmPm == "PM")
				hr24 = parseInt(this.selectedHr)+12

			let value = this.selectedDate +" "+hr24+this.selectedMin

			if (value == "null 00")
				value = "0000-00-00 00:00:00"

			this.$emit("input",value)
			this.$emit("change",value)
		}
	},
	computed: {
		hrs() {
			let hrs = []
			for (var i = 1; i < 13; i++) {
				if (i < 10)
					hrs.push("0"+i)
				else
					hrs.push(i)
			}
			return hrs
		},
		mins() {
			let stepBy = 1
			if (this.minuteStep)
				stepBy = this.minuteStep

			let min = []
			for (var i = 0; i < 60; i += stepBy) {
				if (i == 0)
					min.push(":00")
				else if (i < 10)
					min.push(":0"+i)
				else
					min.push(":"+i)
			}
			return min
		}
	}
}	

</script>